<template>
    <div>
        <div class="spinner-border" role="status">
        </div>
        <p>Cargando... </p>
    </div>
</template>

<script>
export default {
    name: 'BYSpinner',

    data() {
        return {

        };
    },

    mounted() {

    },

    methods: {

    },
};
</script>